// Bornes légales du coefficient de réduction-majoration (CRM / bonus-malus).
const BONUS_MALUS_MIN = 0.5;
const BONUS_MALUS_MAX = 3.5;

export const BONUS_MALUS_ERROR_MESSAGE =
  "Le bonus/malus doit être un nombre compris entre 0.50 et 3.50.";

/**
 * Un champ vide est autorisé (information non renseignée) ; sinon la valeur
 * doit être un nombre (virgule ou point acceptés) entre 0.50 et 3.50 inclus.
 */
export const isBonusMalusInvalid = (value) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return false;
  }
  const cleaned = String(value).trim().replace(",", ".");
  if (!/^\d+(\.\d+)?$/.test(cleaned)) {
    return true;
  }
  const num = parseFloat(cleaned);
  return num < BONUS_MALUS_MIN || num > BONUS_MALUS_MAX;
};

/** Virgule décimale normalisée en point, espaces retirés ; vide inchangé (PER-2490). */
export const normaliserBonusMalus = (value) => {
  if (value === null || value === undefined) return value;
  const texte = String(value).trim();
  return texte === "" ? "" : texte.replace(",", ".");
};

/**
 * Erreurs à poser à l'ouverture de la modification (PER-2490) : une demande
 * enregistrée avec un coefficient hors plage (ex. 0, antérieure à la règle)
 * est signalée en erreur jusqu'à correction, sans attendre une frappe.
 */
export const erreursBonusMalus = (formState) =>
  Object.entries(formState || {})
    .filter(
      ([cle, valeur]) => cle.endsWith("bonus_malus") && isBonusMalusInvalid(valeur),
    )
    .reduce(
      (erreurs, [cle]) => ({ ...erreurs, [cle]: BONUS_MALUS_ERROR_MESSAGE }),
      {},
    );
